export default __webpack_public_path__ + "static/Raden Roro Dini Natalia-fb0d192f475ac2be31e590cee2d328c4.webp";